export default __webpack_public_path__ + "static/logo-1-light-e89bd46c424f6663fe0252d6874d379a.webp";